module.exports = __webpack_public_path__ + "static/media/tooltip_personality.07ae661c.svg";